function selectMyCar(vehicleManufacturer, vehicleModel, vehicleEngineType, vehicleSpecification) {
    var cmsPageId = "";

    $.ajax({
        url: contextPath + "/ws/jfnetwork/vehicle/manufacturers",
        method: "POST",
        data: {
            cmsPageId: cmsPageId
        },
        headers: {
            "X-CSRF-TOKEN": $("input[name='_csrf']").val()
        }
    }).done(function (data) {
        var dropdown = $("#default-manufacturer");

        $(dropdown).find('option:not([value=""])').remove();
        $.each(data.list, function (index, manufacturer) {
            if (manufacturer.value === vehicleManufacturer){
                $(dropdown).append(
                    "<option selected data-image='https://ssl.delti.com/simg/Logos/" + manufacturer.value.replace(" ", "") + ".png' value='" + manufacturer.key + "'>" + manufacturer.value + "</option>");
            } else {
                $(dropdown).append(
                    "<option data-image='https://ssl.delti.com/simg/Logos/" + manufacturer.value.replace(" ", "") + ".png' value='" + manufacturer.key + "'>" + manufacturer.value + "</option>");
            }
        });
        $(dropdown).prop('disabled', false).trigger("focus");
        $(dropdown).parent().show();
        $('#default-manufacturer').trigger("change");
    }).fail(function (jqXHR) {
        $("#carselector-error-div").show();
    });

    // CarSelector Default: load second dropdown (class(aka model))
    $('#default-manufacturer').on('change', function () {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleManufacturer]').val(this.value);
        }
        $("#default-model").prop('disabled', true)[0].options.length = 1;
        $("#default-year-of-manufacture-type").prop('disabled', true)[0].options.length = 1;
        $("#default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);

        if (this.value == "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/classes",
            method: "POST",
            data: {
                manufacturer: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function (data) {
            var dropdown = $("#default-model");
            $(dropdown).find('option:not([value=""])').remove();
            $.each(data.list, function (index, model) {
                if (model.value === vehicleModel){
                    $(dropdown).append(
                        "<option selected value='" + model.key + "'>" + model.value + "</option>");
                } else {
                    $(dropdown).append(
                        "<option value='" + model.key + "'>" + model.value + "</option>");
                }
            });

            if (data.list.length === 1) {
                // select first element
                $(dropdown).val(data.list[0].key);
                $('#default-model').trigger("change");
            }

            $(dropdown).prop('disabled', false).trigger("focus");
            $('#default-model').trigger("change");
        }).fail(function (jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: load third dropdown (type)
    $('#default-model').on('change', function () {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleModel]').val(this.value.split("::")[1]);
        }
        $("#default-year-of-manufacture-type").prop('disabled', true)[0].options.length = 1;
        $("#default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);
        $("#carselector-default-error").fadeOut(300, function () {
            this.remove()
        });

        if (this.value === "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/years-types",
            method: "POST",
            data: {
                carClass: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function (data) {
            var versionDropdown = $("#default-year-of-manufacture-type");
            $(versionDropdown).find('option:not([value=""])').remove();
            $.each(data.yearOfManufactureType, function (index, yearTypes) {
                var yearOfManufactureTypeText = yearTypes.name.split("::")[0] + " " + typeTranslation + " " + yearTypes.name.split("::")[1];
                if (yearOfManufactureTypeText === vehicleSpecification) {
                    $(versionDropdown).append("<option selected value='" + yearTypes.key + "'>" + yearOfManufactureTypeText + "</option>");
                } else {
                    $(versionDropdown).append("<option value='" + yearTypes.key + "'>" + yearOfManufactureTypeText + "</option>");
                }
            });

            if (data.yearOfManufactureType.length == 1) {
                // select first element
                $(versionDropdown).val(data.yearOfManufactureType[0].key);
                $('#default-year-of-manufacture-type').trigger("change");
            } else if (data.yearOfManufactureType.length == 0) {
                $("#carselector-error-div").show();
            }
            $(versionDropdown).prop('disabled', false).trigger("focus");
            $('#default-year-of-manufacture-type').trigger("change");
        }).fail(function (jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: load forth dropdown (type-details)
    $('#default-year-of-manufacture-type').on('change', function () {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleSpecification]').val(this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4]);
        }
        $("#default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);
        $("#carselector-default-error").fadeOut(300, function () {
            this.remove()
        });

        if (this.value == "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/series-versions",
            method: "POST",
            data: {
                carClass: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function (data) {
            var dropdown = $("#default-specific");
            $(dropdown).find('option:not([value=""])').remove();
            var briefTypeDetails = data.seriesVersion.map((typedetails) => {
                    return typedetails.name.split("::")[0] + " kW/" + typedetails.name.split("::")[1] + " PS"+ typedetails.name.split("::")[2];
            });
            var occurrences = {};
            briefTypeDetails.map((typeDetail) =>{
                occurrences[typeDetail] = occurrences[typeDetail] ? occurrences[typeDetail] + 1 : 1;
            });
            $.each(data.seriesVersion, function (index, typedetails) {
                var briefTypeDetails = typedetails.name.split("::")[0] + " kW/" + typedetails.name.split("::")[1] + " PS"+ typedetails.name.split("::")[2];
                var seriesVersionText = briefTypeDetails + " " + (typedetails.name.split("::")[3] && occurrences[briefTypeDetails] > 1 ? standardSizeTranslation + " " + typedetails.name.split("::")[3] + " " + inchTranslation : "");
                if (seriesVersionText === vehicleEngineType) {
                   $(dropdown).append("<option selected value='" + typedetails.key + "::" + typedetails.name.split("::")[4] + "'>" + seriesVersionText + "</option>");
                } else {
                   $(dropdown).append("<option value='" + typedetails.key + "::" + typedetails.name.split("::")[4] + "'>" + seriesVersionText + "</option>");
                }
            });

            if (data.seriesVersion.length === 1) {
                // select first element
                $(dropdown).val(data.seriesVersion[0].key + "::" + data.seriesVersion[0].name.split("::")[4]);
                $('#default-specific').trigger("change");
                $("#carselector-default-submit").prop('disabled', false).trigger("focus");
            } else if (data.seriesVersion.length === 0) {
                $("#carselector-error-div").show();
            }

            $(dropdown).prop('disabled', false).trigger("focus");
            $(dropdown).parent().show();
            $("#default-specific").trigger("change");
        }).fail(function (jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: show submit on fifth dropdown selection
    $("#default-specific").on('change', function () {
        resetError();
        preselect = false;
        if (this.value !== '') {
            $('input[name=vehicleId]').val(this.value.split("::")[0]);
            $('input[name=vehicleEngineType]').val($("#default-specific option:selected").text());
            $('input[name=fuelCode]').val(this.value.split("::")[1]);
            $("#carselector-default-submit").prop('disabled', false).trigger("focus");
        } else {
            $("#carselector-default-submit").prop('disabled', true);
        }
    });

};

function resetError() {
    //reset error message to default and hide previous error
    $("#carselector-error-span").text(defaultErrorMessage);
    $("#carselector-error-div").hide();
}

function saveSelectedCar() {

    $("#searchByBrandForm, #searchCWForm").on("submit", function() {
        document.getElementById('carselector-default-manufacturer').removeAttribute('name');
        document.getElementById('carselector-default-model').removeAttribute('name');
        document.getElementById('carselector-default-year-of-manufacture-type').removeAttribute('name');
        document.getElementById('carselector-default-specific').removeAttribute('name');
        document.getElementById('carselector-tyre-size').removeAttribute('name');

        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";

        $.ajax({
        contentType : "application/json",
            type : "POST",
            url : "/my-account/myCar/saveFromSearch",
            data : JSON.stringify(carForm),
            dataType : 'json',
            beforeSend: function (xhr) {
                xhr.setRequestHeader(header, token);
            }
        });
    });

    $("#carselector-tyre-size").prop('disabled', true).trigger("focus");

    // CarSelector Default: load fift dropdown (type-details)
    $('#carselector-default-specific').on('change', function() {
        resetError();
        $("#carselector-default-error").fadeOut(300, function() {
            this.remove()
        });
        $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
        $("#carselector-default-submit-tyres").prop('disabled', true);
        $("#carselector-default-submit-cw").prop('disabled', true);
        if (this.value == "") {
            return;
        }
        $.ajax({
            url: contextPath + "/delticom/brand/proxy"+"?rsmKBA=" + this.value +"&rsmHersteller="+$("#carselector-default-manufacturer").val()+"&rsmPKWModell="+$("#carselector-default-model").val()+"&rsmPKWVersion="+$("#carselector-default-year-of-manufacture-type").val()
        }).done(function(result) {
            if(result==="NOK"){
                showError();
                return;
            }
            var data = JSON.parse(result);

            var dropdown = $("#carselector-tyre-size");
            $(dropdown).find('option:not([value=""])').remove();
            $.each(data, function(index, typedetails) {
                if(data.selectedKey!=typedetails.v){
                    $(dropdown).append( "<option value='" + typedetails.v + "'>" + typedetails.d +"</option>" );
                }else{
                    $(dropdown).append( "<option selected value='" +typedetails.v + "'>"  +typedetails.d+"</option>" );
                }
            });
            if (data.length === 1 && $(".preselectedCar-ab-testing").length === 0) {
                // select first element
                $(dropdown).val(data[0].v);
                $("#carselector-default-submit-tyres").prop('disabled', false);
                $("#carselector-default-submit-cw").prop('disabled', false);
                $('#carselector-tyre-size').trigger("change");
            } else if (data.length == 0) {
                showError();
            } else {
                hideError();
            }
            $(dropdown).prop('disabled', false).trigger("focus");
            $(dropdown).parent().show();
            $("body").trigger($.Event("carselector-default-specific-done-loading"));
        }).fail(function(jqXHR) {
            // show foundation alert-box
            $("#carselector-error-div").show();
        });
    });

    $("#carselector-tyre-size").on('change', function() {
        preselect = false;
        var carselectorSubmitTyres = $("#carselector-default-submit-tyres");
        var carselectorSubmitCW = $("#carselector-default-submit-cw");
        var carselectorTyreSize = $("#carselector-tyre-size");
        if (this.value != '') {
            populateForm(carselectorTyreSize.val());
            carselectorSubmitTyres.prop('disabled', false);
            carselectorSubmitTyres.show();
            carselectorSubmitCW.prop('disabled', false);
            carselectorSubmitCW.show();
            $("input[name=vehicle_ids]").val($("input[name=vehicleId]").val());
        } else {
            carselectorSubmitTyres.prop('disabled', true);
            carselectorSubmitCW.prop('disabled', true);
        }
    });


    var carForm = {};
    carForm["id"] = null;

    $("#carselector-default-manufacturer").on('change', function(){
        preselect = false;
        if (this.value !== '') {
            $('input[name=vehicleManufacturer]').val(this.value);
            carForm["vehicleManufacturer"] = this.value;
        }
    });

    $("#carselector-default-model").on('change', function(){
        preselect=false;
        if (this.value !== '') {
            $('input[name=vehicleModel]').val(this.value.split("::")[1]);
            carForm["vehicleModel"] = this.value.split("::")[1];
        }
    });

    $("#carselector-default-year-of-manufacture-type").on('change', function(){
        preselect=false;
        if (this.value !== '') {
            $('input[name=vehicleSpecification]').val(this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4]);
            carForm["vehicleSpecification"] = this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4];
        }
    });

    $("#carselector-default-specific").on('change', function(){
        preselect=false;
        if (this.value !== '') {
            $("#jf_sizeDiv").addClass("last-select");
            $('input[name=vehicleId]').val(this.value.split("::")[0]);
            $('input[name=vehicleEngineType]').val($("#carselector-default-specific option:selected").text());
            $('input[name=fuelCode]').val(this.value.split("::")[1]);
            carForm["vehicleEngineType"] = $("#carselector-default-specific option:selected").text();
            carForm["fuelCode"] = this.value.split("::")[1];
        }
    });

    $("#carselector-default-manufacturer").on('change-car', function(){
        preselect = false;
        if (this.value !== '') {
            $('input[name=vehicleManufacturer]').val(this.value);
            carForm["vehicleManufacturer"] = this.value;
        }
    });

    $("#carselector-default-model").on('change-car', function(){
        preselect=false;
        if (this.value !== '') {
            $('input[name=vehicleModel]').val(this.value.split("::")[1]);
            carForm["vehicleModel"] = this.value.split("::")[1];
        }
    });

    $("#carselector-default-year-of-manufacture-type").on('change-car', function(){
        preselect=false;
        if (this.value !== '') {
            $('input[name=vehicleSpecification]').val(this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4]);
            carForm["vehicleSpecification"] = this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4];
        }
    });

    $("#carselector-default-specific").on('change-car', function(){
        preselect=false;
        if (this.value !== '') {
            $('input[name=vehicleId]').val(this.value.split("::")[0]);
            $('input[name=vehicleEngineType]').val($("#carselector-default-specific option:selected").text());
            $('input[name=fuelCode]').val(this.value.split("::")[1]);
            carForm["vehicleEngineType"] = $("#carselector-default-specific option:selected").text();
            carForm["fuelCode"] = this.value.split("::")[1];
        }
    });

    var populateForm = function(data) {
        var values = data.split("|"); // split by pipe creates individual values
        var formValues = {
            width: values[0],
            profile: values[1],
            constructionType: values[2],
            size: values[3],
            loadIndex: values[4],
            speedRating: values[5]
        };
        for (var key in formValues) {
            $("#searchByBrandForm input[name='" + key +"']").val(formValues[key]);
        }
    };

    var showError = function(){
        $("#carselector-error-div").show(noResults);
    };

    var hideError = function(){
        $("#carselector-error-div").hide();
    };
}